module.exports = __webpack_public_path__ + "static/media/blanket.2684513c.svg";